export default __webpack_public_path__ + "static/media/aleksandar_l.1f4e5017.jpg";